import { FiShoppingBag, FiX } from 'react-icons/fi';
import Button from '../atoms/Button';
import TimerChip from '../atoms/TimerChip';
import { CheckoutSessionDTO } from '../../models/checkout-session';
import { describeItems } from './OrderSummary';

interface ResumeCardProps {
  session: CheckoutSessionDTO;
  onResume: () => void;
  // Sin esto no se ofrece (por ejemplo, con un CVU ya pedido).
  onStartOver?: () => void;
  // Cerrar el aviso sin soltar la reserva.
  onDismiss?: () => void;
}

/**
 * "Tenés una compra sin terminar": aparece en la ficha cuando hay una sesión
 * abierta en este navegador (recargó, volvió con Atrás o abrió el recordatorio).
 * Ocupa el lugar del botón de compra, así no tapa la ficha ni quedan dos
 * botones para lo mismo. Va en columna: en la compu esa columna es angosta.
 * Fondo sólido: va sobre el banner desenfocado de la ficha.
 */
const ResumeCard = ({
  session, onResume, onStartOver, onDismiss,
}: ResumeCardProps) => (
  <section
    className="relative flex flex-col gap-4 rounded-3xl border border-border-secondary bg-surface-base p-4 text-text-primary shadow-lg md:p-5"
    aria-label="Compra sin terminar"
  >
    {onDismiss && (
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Cerrar"
        className="absolute right-2 top-2 flex h-9 w-9 items-center justify-center rounded-full text-text-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
      >
        <FiX aria-hidden />
      </button>
    )}
    <div className="flex items-start gap-3 pr-8">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500/10 text-primary-500" aria-hidden>
        <FiShoppingBag className="h-5 w-5" />
      </span>
      <div className="flex min-w-0 flex-col gap-1">
        <h2 className="font-bold">Tenés una compra sin terminar</h2>
        <span className="text-sm text-text-secondary">
          {`${describeItems(session)} · ${session.contact ? 'con tus datos cargados' : 'falta completar tus datos'}`}
        </span>
        <div className="mt-1">
          <TimerChip expiresAt={session.expires_at} label="Entradas reservadas" />
        </div>
      </div>
    </div>
    <div className="flex flex-col gap-2">
      <Button variant="primary" onClick={onResume}>Seguir con la compra</Button>
      {onStartOver && (
        <button
          type="button"
          onClick={onStartOver}
          className="min-h-[44px] rounded-full px-4 font-semibold text-text-secondary underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
        >
          Empezar de nuevo
        </button>
      )}
    </div>
  </section>
);

export default ResumeCard;
